import { useMutation } from '@apollo/client';
import { unwrap } from 'api/schema/utils';
import REMOVE_ORDER_MODEL from 'api/mutations/REMOVE_ORDER_MODEL';
import Scrollable from 'common/Scrollable';
import React, { memo, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { OrderSpecificationContext } from 'views/OrdersList/OrderSpecificationProvider';
import { useTranslation } from 'react-i18next';
import '../../../OrdersListCommon.scss';
import './SpecificationLeftSideBar.scss';
import 'common/Card/Card.scss';
import OrderModelButton from 'views/OrdersList/OrderModelButton';
import GET_ORDER_SUPPLIERS from '../../../../../api/queries/GET_ORDER_SUPPLIERS';
const SpecificationLeftSideBar = () => {
    var _a, _b;
    const { order, folder, refetchFolderContentsData } = useContext(OrderSpecificationContext);
    const { t } = useTranslation('orders');
    const history = useHistory();
    const getPath = (orderModelNode) => {
        var _a, _b, _c, _d;
        return ((_c = (_b = (_a = orderModelNode === null || orderModelNode === void 0 ? void 0 : orderModelNode.modelSpecificationNode) === null || _a === void 0 ? void 0 : _a.folder) === null || _b === void 0 ? void 0 : _b.path) === null || _c === void 0 ? void 0 : _c.map((path) => `${path.name} / `).join('')) + ((_d = orderModelNode === null || orderModelNode === void 0 ? void 0 : orderModelNode.modelSpecificationNode) === null || _d === void 0 ? void 0 : _d.itemCode);
    };
    const [removeOrderModel] = useMutation(REMOVE_ORDER_MODEL, {
        refetchQueries: [{ query: GET_ORDER_SUPPLIERS, variables: { id: order === null || order === void 0 ? void 0 : order.id } }],
    });
    const handleRemoveOrderModel = useCallback((modelSpecificationId) => {
        var _a;
        const orderModelId = (_a = unwrap(order === null || order === void 0 ? void 0 : order.models).find((e) => e.modelSpecificationNode.id === modelSpecificationId)) === null || _a === void 0 ? void 0 : _a.id;
        removeOrderModel({
            variables: {
                orderModelId,
            },
        }).then(() => {
            refetchFolderContentsData(folder.id);
        });
    }, [folder, order === null || order === void 0 ? void 0 : order.models, refetchFolderContentsData, removeOrderModel]);
    const goToSpecificationSummary = useCallback((modelSpecificationId) => {
        history.push(`/specifications/details/${modelSpecificationId}/summary`);
    }, [history]);
    return (React.createElement(Scrollable, { className: "LeftSideBar" }, order && ((_a = unwrap(order === null || order === void 0 ? void 0 : order.models)) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement(React.Fragment, null, (_b = unwrap(order === null || order === void 0 ? void 0 : order.models)) === null || _b === void 0 ? void 0 : _b.map((modelNode) => {
        var _a;
        return (React.createElement(React.Fragment, { key: modelNode.modelSpecificationNode.id },
            React.createElement("div", { className: "Card nav-item" },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", { className: "nav-item-icon-wrapper" }),
                    React.createElement("div", { className: "nav-item-value", title: getPath(modelNode) }, getPath(modelNode))),
                React.createElement(OrderModelButton, { goToSpecificationSummary: goToSpecificationSummary, handleRemoveOrderModel: handleRemoveOrderModel, specId: (_a = modelNode === null || modelNode === void 0 ? void 0 : modelNode.modelSpecificationNode) === null || _a === void 0 ? void 0 : _a.id }))));
    }))) : (React.createElement("div", null, t('specification_lefttab_placeholder')))));
};
export default memo(SpecificationLeftSideBar);
